window.ttx = window.ttx || {};
ttx.auth = {};

/** 登录页面 URL，来自 ttx.ajax.config().auth */
ttx.auth._getLoginUrl = function () {
    var cfg = typeof ttx.ajax.config === 'function' ? ttx.ajax.config() : {};
    return (cfg.auth || '/api/users') + '/login.html';
};
/** localStorage 中 token 的 key */
ttx.auth.tokenKey = 'token';
/** localStorage 中 refresh_token 的 key */
ttx.auth.refreshTokenKey = 'refresh_token';
/** 登录成功后的回调列表 */
ttx.auth._callbacks = [];
/** 正在进行的刷新请求（并发去重） */
ttx.auth._refreshing = null;
/** 是否处于「需要重新登录」状态：此时禁止静默续期，避免续期成功把登录框瞬间关掉 */
ttx.auth._requiringLogin = false;
/** 弹出登录框时的 token 快照：只有 token 发生变化才认为登录成功 */
ttx.auth._tokenAtShow = null;

ttx.auth.isLoggedIn = function () {
    return !!localStorage.getItem(ttx.auth.tokenKey);
};

/**
 * 用 refresh_token 换新 access_token（并发请求只发一次）
 * @returns {Promise<boolean>} 是否刷新成功
 */
ttx.auth.refresh = function () {
    if (ttx.auth._refreshing) return ttx.auth._refreshing;
    // 登录框已弹出：会话已被判定失效，禁止静默续期把登录框顶掉
    if (ttx.auth._requiringLogin) return Promise.resolve(false);

    var refreshToken = null;
    try { refreshToken = localStorage.getItem(ttx.auth.refreshTokenKey); } catch (e) { refreshToken = null; }
    if (!refreshToken) return Promise.resolve(false);

    ttx.auth._refreshing = fetch('/api/auth/refresh', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken: refreshToken })
    })
        .then(function (res) { return res.json(); })
        .then(function (res) {
            // 续期期间登录框已被弹出（会话判定失效），丢弃本次续期结果
            if (ttx.auth._requiringLogin) return false;
            var data = res && res.data;
            if (!res || Number(res.code) !== 200 || !data || !data.access_token) return false;
            try {
                localStorage.setItem(ttx.auth.tokenKey, data.access_token);
                if (data.refresh_token) {
                    localStorage.setItem(ttx.auth.refreshTokenKey, data.refresh_token);
                }
            } catch (e) { /* 隐私模式下写入失败 */ }
            return true;
        })
        .catch(function () { return false; })
        .then(function (ok) {
            ttx.auth._refreshing = null;
            return ok;
        });

    return ttx.auth._refreshing;
};

/** 清除本地登录态（不请求后端） */
ttx.auth.clear = function () {
    try {
        localStorage.removeItem(ttx.auth.tokenKey);
        localStorage.removeItem(ttx.auth.refreshTokenKey);
    } catch (e) { /* ignore */ }
};

/**
 * 退出登录：先吊销服务端 refresh_token，再清除本地登录态
 * @returns {Promise<boolean>}
 */
ttx.auth.logout = function () {
    var refreshToken = null;
    try { refreshToken = localStorage.getItem(ttx.auth.refreshTokenKey); } catch (e) { refreshToken = null; }
    var finish = function () {
        ttx.auth.clear();
        return true;
    };
    if (!refreshToken) return Promise.resolve(finish());

    return fetch('/api/auth/logout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken: refreshToken })
    })
        .then(finish)
        .catch(finish);
};

ttx.auth.onLogin = function (callback) {
    if (typeof callback === 'function') {
        ttx.auth._callbacks.push(callback);
    }
};

ttx.auth._fireLogin = function () {
    var cbs = ttx.auth._callbacks;
    ttx.auth._callbacks = [];
    cbs.forEach(function (fn) { fn(); });
};

ttx.auth._injectStyle = function () {
    if (document.getElementById('tx-auth-modal-style')) return;
    var style = document.createElement('style');
    style.id = 'tx-auth-modal-style';
    style.textContent = [
        '.tx-auth-modal-mask {',
        '  position: fixed; top: 0; left: 0; width: 100%; height: 100%;',
        '  background: rgba(0,0,0,0.5); z-index: 9999;',
        '  display: flex; align-items: center; justify-content: center;',
        '}',
        '.tx-auth-modal-box {',
        '  width: 420px; height: 480px;',
        '  background: var(--xw_navbar-dropdown-bg, #fff);',
        '  border-radius: 0px; overflow: hidden;',
        '  box-shadow: 0 4px 20px rgba(0,0,0,0.2);',
        '}',
        '.tx-auth-modal-box iframe {',
        '  width: 100%; height: 100%; border: none;',
        '}',
    ].join('\n');
    document.head.appendChild(style);
};

ttx.auth.show = function () {
    // 进入「需重新登录」状态：禁止续期，并记录当前 token 快照，
    // 只有 token 发生变化（真正完成登录）才自动关闭，避免残留 token 把弹框瞬间关掉
    ttx.auth._requiringLogin = true;
    ttx.auth._tokenAtShow = ttx.auth.isLoggedIn() ? localStorage.getItem(ttx.auth.tokenKey) : null;
    if (ttx.auth._modalBox) return;
    ttx.auth._injectStyle();

    var mask = document.createElement('div');
    mask.className = 'tx-auth-modal-mask';
    mask.innerHTML = '<div class="tx-auth-modal-box"><iframe src="' + ttx.auth._getLoginUrl() + '"></iframe></div>';
    document.body.appendChild(mask);
    ttx.auth._modalBox = mask;

    window.addEventListener('message', function onMsg(e) {
        ttx.console.log('auth message', e);
    }, false);

    ttx.auth._pollTimer = setInterval(function () {
        var token = null;
        try { token = localStorage.getItem(ttx.auth.tokenKey); } catch (e) { token = null; }
        if (token && token !== ttx.auth._tokenAtShow) {
            ttx.auth.close();
            ttx.auth._fireLogin();
        }
    }, 500);
};

ttx.auth.close = function () {
    ttx.auth._requiringLogin = false;
    ttx.auth._tokenAtShow = null;
    if (ttx.auth._pollTimer) {
        clearInterval(ttx.auth._pollTimer);
        ttx.auth._pollTimer = null;
    }
    if (ttx.auth._modalBox) {
        document.body.removeChild(ttx.auth._modalBox);
        ttx.auth._modalBox = null;
    }
};

ttx.auth.init = function () {
    if (!ttx.auth.isLoggedIn()) {
        ttx.auth.show();
    }
};
